const getIsAnchorLink = url => {
  if (!url) return false;
  return url.startsWith('#');
};
export { getIsAnchorLink };
//# sourceMappingURL=getIsAnchorLink.js.map
